import React, { useContext, useEffect, useMemo, useState } from 'react'
import ResponsiveModal from '../modal/ResponsiveModal'
import UserContext from '../contexts/UserContext';
import { SubscriptionPlanPrice } from '../models/SubscriptionPlanPrice';
import SmallButton from '../buttons/SmallButton';
import { useTranslation } from 'react-i18next';
import PlanSelectRow from './PlanSelectRow';
import { subscriptionPageRoute, usePathReconstructor } from '../config/pageRoutes';
import { Divider } from '@mui/material';

type Props = {
    prices: SubscriptionPlanPrice[];
}

const NoSubscriptionCard = ({ prices }: Props) => {
        // const [acceptTerms, setAcceptTerms] = useState(false);
        // const [acceptRecurring, setAcceptRecurring] = useState(false);
    const { currentSubscription } = useContext(UserContext);
    const { copyParamsFromPath } = usePathReconstructor();
    const { t } = useTranslation();
    const uniquePlanIds = useMemo(() => {
        return Array.from(new Set(prices.map(price => price.planId)));
    }, [prices]);
    const [selectedPlanId, setSelectedPlanId] = useState<string | null>(null);
    const selectablePrices = useMemo(() => {
        if (selectedPlanId == null) return [];
        return prices.filter(price => selectedPlanId === price.planId);
    }, [prices, uniquePlanIds, selectedPlanId]);
    const [selectedPrice, setSelectedPrice] = useState<SubscriptionPlanPrice | null>(null);

    useEffect(() => {
        if (selectablePrices.length > 0) {
            setSelectedPrice(selectablePrices[0]);
        } else {
            setSelectedPrice(null);
        }
    }, [selectablePrices]);

    async function onConfirmClick() {
        const url = copyParamsFromPath(subscriptionPageRoute.path) + "?price_id=" + selectedPrice?.id;
        window.location.href = url;
    }

    return (
        <>
            {currentSubscription == null && (
                <>
                    <div className="bg-secondary-pale bg-opacity-80 rounded-[8px] shadow-lg px-2 py-2">
                        <div className="flex flex-row justify-between gap-2">
                            <div className="text-primary-dark font-bold font-[17px]">
                                {t(`payment.subscription_plans.FREE`)}
                            </div>
                        </div>
                        <div>
                            {t("payment.plan_descriptions.FREE")}
                        </div>
                        <div className="mt-3 mb-3">
                            <Divider />
                        </div>
                        <div className="text-primary-dark font-bold font-[17px] ">
                            {t("payment.available_plans")}
                        </div>
                        <div className="flex flex-col gap-3 mt-1">
                            {uniquePlanIds.map(planId => (
                                <div key={planId} className="bg-primary rounded-[8px] shadow-sm px-2 py-2 text-white flex-col gap-3">
                                    <div className="grow">
                                        <div className="font-bold text-[16px] text-white">
                                            {t(`payment.subscription_plans.${planId}`)}
                                        </div>
                                        <div>
                                            {t("payment.plan_descriptions." + planId)}
                                        </div>
                                    </div>
                                    <div className="mt-1">
                                        <SmallButton
                                            onClick={() => setSelectedPlanId(planId)}
                                            variant="strike"
                                        >
                                            {t("payment.subscribe")}
                                            {/*{t("payment.subscribe")} */}
                                        </SmallButton>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-center items-center mt-6">
                            <img
                                src={process.env.REACT_APP_PUBLIC_URL + '/assets/barion-banner-lightmode.svg'}
                                alt="Barion banner"
                                style={{ maxWidth: '200px', width: '100%' }}
                            />
                        </div>
                    </div>
                </>
            )}
            <ResponsiveModal
                open={selectedPlanId !== null}
                handleClose={() => setSelectedPlanId(null)}
            >
                <>
                    <div className="text-[18px] text-primary-dark font-bold text-center">
                        {t("payment.confirm_subscription")}
                    </div>
                    <div className="px-2 pt-2">
                        <div className="flex flex-col gap-3">
                            {selectablePrices.map(price => (
                                <PlanSelectRow
                                    key={price.id}
                                    price={price}
                                    selectedId={selectedPrice?.id || -1}
                                    onClick={() => {
                                        setSelectedPrice(price);
                                    }}
                                />
                            ))}
                        </div>
                        {/* A két checkbox eltávolítva kérésre. */}
                        <div className="flex justify-end mt-5 gap-3">
                            <SmallButton
                                variant="strike"
                                disabled={selectedPrice == null}
                                onClick={onConfirmClick}
                            >
                                {t("payment.continue_to_payment")}
                            </SmallButton>
                            <SmallButton
                                onClick={() => {
                                    setSelectedPlanId(null);
                                }}
                                variant="outlined"
                            >
                                {t("common.cancel")}
                            </SmallButton>
                        </div>
                    </div>
                </>
            </ResponsiveModal>
        </>
    )
}

export default NoSubscriptionCard